/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosText } from "@components/elements";
import { LicenseCardCoreFragment } from "@cosmos/hygraph-schema";

import { VStack } from "@panda/jsx";

import { LicenseCardDescription } from "./LicenseCardDescription.molecule";
import { DEFAULT_SEAT_PRICE_TEMPLATE } from "@components/constants";

export interface LicenseCardCoreProps extends LicenseCardCoreFragment {
	priceStr?: string;
}

export const LicenseCardCore = ({ title, description, priceStr }: LicenseCardCoreProps): React.JSX.Element => {
	let adjustedHtml = description?.html || "";
	if (adjustedHtml?.includes(DEFAULT_SEAT_PRICE_TEMPLATE)) {
		adjustedHtml = adjustedHtml.replaceAll(DEFAULT_SEAT_PRICE_TEMPLATE, priceStr || "");
	}

	return (
		<VStack alignItems="flex-start" gap="eds.dimension.16" position="relative">
			<CosmosText variant="headingLG">{title}</CosmosText>
			{adjustedHtml ? <LicenseCardDescription html={adjustedHtml} /> : null}
		</VStack>
	);
};
